import React from 'react';
import { Folder, BookOpen, Target, Lightbulb, GitBranch } from 'lucide-react';

const JourneyPage = () => {
  return (
    <div className="min-h-screen bg-bg-base p-6 lg:p-8" data-testid="journey-page">
      <div className="max-w-5xl mx-auto animate-fade-up">
        <div className="mb-8">
          <h1 className="font-display text-4xl font-bold text-text-primary mb-2">Journey Tree</h1>
          <p className="text-text-secondary">Your path, visualized</p>
        </div>

        {/* Coming Soon — elevated design */}
        <div className="relative overflow-hidden rounded-2xl border border-border bg-bg-surface">
          {/* Decorative gradients */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-gold-light/30 via-transparent to-transparent rounded-full blur-2xl" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-gradient-to-tr from-sage-light/20 via-transparent to-transparent rounded-full blur-2xl" />

          <div className="relative z-10 py-20 px-8 text-center">
            {/* Animated icon cluster */}
            <div className="flex items-center justify-center gap-3 mb-8">
              <div className="w-10 h-10 bg-gold-light rounded-lg flex items-center justify-center animate-float" style={{ animationDelay: '0ms' }}>
                <BookOpen className="text-gold" size={18} />
              </div>
              <div className="w-14 h-14 bg-sage-light rounded-xl flex items-center justify-center animate-float" style={{ animationDelay: '200ms' }}>
                <Folder className="text-sage" size={24} />
              </div>
              <div className="w-10 h-10 bg-amber-light rounded-lg flex items-center justify-center animate-float" style={{ animationDelay: '400ms' }}>
                <Target className="text-amber" size={18} />
              </div>
            </div>

            <h2 className="font-display text-3xl font-bold text-text-primary mb-3">
              Your story, visualized
            </h2>
            <p className="text-text-secondary max-w-lg mx-auto mb-8 leading-relaxed">
              The Journey Tree will weave together your entries, lessons, and milestones into a
              visual timeline of how you got here. Keep logging — the tree grows with you.
            </p>

            {/* Preview timeline dots */}
            <div className="flex items-center justify-center gap-4 mb-8">
              <div className="flex flex-col items-center gap-1.5">
                <div className="w-3 h-3 rounded-full bg-gold" />
                <div className="w-px h-6 bg-border" />
                <div className="w-2 h-2 rounded-full bg-sage" />
                <div className="w-px h-6 bg-border" />
                <div className="w-2.5 h-2.5 rounded-full bg-amber" />
                <div className="w-px h-6 bg-border" />
                <div className="w-2 h-2 rounded-full bg-teal" />
                <div className="w-px h-6 bg-border" />
                <div className="w-3 h-3 rounded-full bg-lavender" />
              </div>
            </div>

            <div className="inline-flex items-center gap-2 px-4 py-2 bg-bg-surface-alt/80 rounded-full text-sm text-text-tertiary">
              <div className="w-1.5 h-1.5 bg-gold rounded-full animate-pulse" />
              Coming soon
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JourneyPage;
